const HTTP_PROTOCOLS = ['http:', 'https:'] as const;
const [HTTP_PROTOCOL_HTTP, HTTP_PROTOCOL_HTTPS] = HTTP_PROTOCOLS;
export type HttpProtocol = (typeof HTTP_PROTOCOLS)[number];

export const isHttpProtocol = (value: unknown): value is HttpProtocol =>
  value === HTTP_PROTOCOL_HTTP || value === HTTP_PROTOCOL_HTTPS;
